/*
 * Un maestro una volta sola negli elenchi (segnalazione del 04/11/2026). Lo staff della struttura ha una riga per
 * ogni sport del maestro: in un corso o in una lezione con piu' sport, chi ne insegna due (es. sci e roller)
 * compariva due volte fra le scelte. Si toglie il doppione dopo aver filtrato per sport, cosi' resta chi insegna
 * almeno uno degli sport scelti. `chiave`: il campo con l'id del maestro.
 */
export const maestriUnici = (elenco, chiave = 'value') => {
    const visti = new Set();
    return (elenco || []).filter((maestro) => {
        const id = String(maestro?.[chiave]);
        if (visti.has(id)) return false;
        visti.add(id);
        return true;
    });
};

export default maestriUnici;
